import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { getTailwindUtility } from "@utils";

// Container is used primarily to give content a max-width
// using the tailwind `container` class

const Container = ({
  hasPadding,
  hasAutoMargin,
  size,
  className: _className,
  children,
}) => {
  const wrapperClassName = clsx({
    "w-full": true,
    "px-4 sm:px-8 md:px-16 lg:px-6": hasPadding,
  });

  const className = clsx(
    {
      "w-full": true,
      "mx-auto": hasAutoMargin,
      [`max-w-${size}`]: true,
    },
    _className
  );

  if (size === "full") {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={wrapperClassName}>
      <div className={className}>{children}</div>
    </div>
  );
};

Container.propTypes = {
  size: PropTypes.oneOf(Object.keys(getTailwindUtility("maxWidth"))),
  hasPadding: PropTypes.bool,
  hasAutoMargin: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Container.defaultProps = {
  size: "lg",
  hasPadding: true,
  hasAutoMargin: true,
  className: "",
};

export default Container;
